import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiEdit } from "react-icons/fi";
import { AiFillDelete } from "react-icons/ai";
import { DeleteAdminProduct, DeleteEvent } from "../../util/Auth/APIs";
import { toast, ToastContainer } from "react-toastify";
import deleteImg from "../../assets/delete.png";
import editImg from "../../assets/edit.png";

import "./Table.css";

const EventsTable = ({ data }) => {
  const [deleteloader, setDeleteLoader] = useState(false);
  const [deletingItemId, setDeletingItemId] = useState("");
  const [productList, setProductList] = useState(data);



  useEffect(() => {
    setProductList(data);
  }, [data]);

  const navigate = useNavigate();

  const removeItem = async (id,e) => {
    e.stopPropagation();
    setDeleteLoader(true);
    setDeletingItemId(id);

    
    try {
      const res = await DeleteEvent(id);
      setDeleteLoader(false);
      toast.success("Event deleted successfully");
      setProductList(data.filter((item) => item._id !== id));
    } catch (error) {
      toast.error("Something went wrong");
      setDeleteLoader(false);
      console.log(error);
    }

  };



  const divStyle = {
    padding: "0",
    textAlign: "center",
    marginTop: "10px",
  };

  return (
    <div className="table-container">
      <table className="Table">
        <thead className="table-head">
          <tr>
            <th>ID</th>
            <th>Title</th>
            <th>Date</th>
            <th>Start</th>
            <th>End</th>
            <th>Discription</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {productList.map((item, index) => (
            <tr key={item._id} onClick={()=>navigate(`/events/details/${item._id}`)}>
              <td>{index + 1}</td>
              <td>
                {item?.basicInfo?.name
                  ? item?.basicInfo?.name.split(" ").slice(0, 2).join(" ")
                  : ""}

                {item?.basicInfo?.name.split(" ").length > 2 ? "..." : ""}
              </td>
              <td>{item?.basicInfo?.start?.date?.slice(0, 10)}</td>
              <td>{item?.basicInfo?.start?.time}</td>
              <td>{item?.basicInfo?.end?.time}</td>
              <td>
                {item?.basicInfo?.description
                  ? item.basicInfo.description.split(" ").slice(0, 3).join(" ")
                  : ""}
                {item?.basicInfo?.description &&
                item.basicInfo.description.split(" ").length > 3
                  ? " ..."
                  : ""}
              </td>

              <td>
                <div className="d-flex ">
                  <div
                    onClick={(e) =>{ 
                      navigate(`/events/edit/${item?._id}?tab=basic-info`);
                      e.stopPropagation();

                    
                    
                    }}
                    className="edit"
                  >
                    <img src={editImg} alt="edit" />
                  </div>

                  <div onClick={(e) => removeItem(item?._id,e)} className="delete">
                    {deleteloader && deletingItemId === item?._id ? (
                      <div
                        className="spinner-border text-white spinner-border-sm"
                        role="status"
                      ></div>
                    ) : (
                      <img src={deleteImg} alt="delete" />
                    )}
                  </div>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
        <ToastContainer />
      </table>
    </div>
  );
};

export default EventsTable;
